require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ein-spannender-ausblick.json") })
        }
      }, "path---ein-spannender-ausblick");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ein-spannender-ausblick!./.cache/json/ein-spannender-ausblick.json
// module id = 420
// module chunks = 231608221292675